import React from 'react';
import { Box, Typography, Divider, List, ListItem, ListItemText, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import './IntroCart.css';

const IntroCart = ({ cart, total, onDelete }) => {
    return (
        <Box className="cart-container">
            <Typography className="cart-title">Your Cart</Typography>
            <Divider className="cart-divider" />

            {cart.length === 0 ? (
                <Typography className="cart-empty">Your cart is empty. Add some software to get started!</Typography>
            ) : (
                <>
                    <List className="cart-list">
                        {cart.map((item) => (
                            <ListItem
                                key={item.name}
                                className="cart-list-item"
                                secondaryAction={
                                    <IconButton
                                        edge="end"
                                        aria-label="delete"
                                        onClick={() => onDelete(item.software)}
                                        className="cart-delete-btn"
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                }
                            >
                                <ListItemText
                                    primary={<span className="cart-item-name">{item.name}</span>}
                                    secondary={<span className="cart-item-price">${item.price}/user/month</span>}
                                />
                            </ListItem>
                        ))}
                    </List>
                    <Box className="cart-total-section">
                        <Typography className="cart-total-label">Total:</Typography>
                        <Typography className="cart-total-value">${total}/month</Typography>
                    </Box>
                </>
            )}
        </Box>
    );
};

export default IntroCart; 